import { APIs, API_BASE_URL, SERVICEURL } from "../constants/Constants";
import axiosInterceptor from "../helpers/Interceptor";

export const getStudyCommunicationData = async (studyId) => {
  try {
    const response = await axiosInterceptor.post(
      // API_BASE_URL + SERVICEURL + APIs.GETSTUDYDATA,
      API_BASE_URL + SERVICEURL + APIs.COMMUNICATIONDATA,
      {
        data: {
          studyId: studyId,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const sendMessageService = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      // API_BASE_URL + SERVICEURL + APIs.GETSTUDYDATA,
      API_BASE_URL + SERVICEURL + APIs.SENDFEEDBACK,
      {
        data: body,
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};
